import React, { createContext, useContext, useState, useEffect } from 'react';
import distributorApi from '../utils/distributorApi';

const DistributorAuthContext = createContext(null);

// ── Context مصادقة مستقل تماماً عن AuthContext الخاص بالمستخدمين العاديين ──
// جلسة الموزع محفوظة تحت مفاتيح localStorage مختلفة (dist_token / dist_user)
// حتى لا تتعارض مع جلسة أي مستخدم عادي مسجّل دخوله على نفس المتصفح.
export const DistributorAuthProvider = ({ children }) => {
  const [distributor, setDistributor] = useState(() => {
    try { return JSON.parse(localStorage.getItem('dist_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('dist_token');
    if (token) {
      distributorApi.get('/distributor/me')
        .then(res => {
          setDistributor(res.data);
          localStorage.setItem('dist_user', JSON.stringify(res.data));
        })
        .catch(() => {
          localStorage.removeItem('dist_token');
          localStorage.removeItem('dist_refreshToken');
          localStorage.removeItem('dist_user');
          setDistributor(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (phone, password) => {
    const res = await distributorApi.post('/distributor/login', { phone, password });
    localStorage.setItem('dist_token', res.data.token);
    localStorage.setItem('dist_refreshToken', res.data.refreshToken);
    localStorage.setItem('dist_user', JSON.stringify(res.data.distributor));
    setDistributor(res.data.distributor);
    return res.data;
  };

  const refresh = async () => {
    const res = await distributorApi.get('/distributor/me');
    setDistributor(res.data);
    localStorage.setItem('dist_user', JSON.stringify(res.data));
    return res.data;
  };

  const logout = () => {
    const refreshToken = localStorage.getItem('dist_refreshToken');
    if (refreshToken) distributorApi.post('/distributor/logout', { refreshToken }).catch(()=>{});
    localStorage.removeItem('dist_token');
    localStorage.removeItem('dist_refreshToken');
    localStorage.removeItem('dist_user');
    setDistributor(null);
  };

  return (
    <DistributorAuthContext.Provider value={{ distributor, login, logout, refresh, loading }}>
      {children}
    </DistributorAuthContext.Provider>
  );
};

export const useDistributorAuth = () => useContext(DistributorAuthContext);
